var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0061 12.6C14.6588 12.6 16.8091 10.451 16.8091 7.8C16.8091 5.14903 14.6588 3 12.0061 3C9.3535 3 7.20312 5.14903 7.20312 7.8C7.20312 10.451 9.3535 12.6 12.0061 12.6Z",
    stroke: "#0100C6",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.5996C3 16.6316 7.03452 12.5996 12.0056 12.5996C16.9767 12.5996 21.0113 16.6316 21.0113 21.5996",
    stroke: "#0100C6",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActive);
export default __webpack_public_path__ + "static/media/account-active.989dacf134b4d1caf868d33a5babb0ee.svg";
export { ForwardRef as ReactComponent };